/**
 * Mengeneinheiten.
 *
 * Der `code` ist der Wert, der am Artikel gespeichert wird. `unece` ist der
 * Code aus UN/ECE Recommendation 20 - den verlangt die E-Rechnung
 * (XRechnung/ZUGFeRD) fuer jede Position, dort ist "Stueck" kein gueltiger
 * Wert, sondern "H87".
 */
export const UNITS = {
    STK: { code: 'STK', label: 'Stueck', short: 'Stk', unece: 'H87', fractional: false },
    PAK: { code: 'PAK', label: 'Packung', short: 'Pak', unece: 'PK', fractional: false },
    KAR: { code: 'KAR', label: 'Karton', short: 'Kar', unece: 'CT', fractional: false },
    PAL: { code: 'PAL', label: 'Palette', short: 'Pal', unece: 'PF', fractional: false },
    KG: { code: 'KG', label: 'Kilogramm', short: 'kg', unece: 'KGM', fractional: true },
    G: { code: 'G', label: 'Gramm', short: 'g', unece: 'GRM', fractional: true },
    L: { code: 'L', label: 'Liter', short: 'l', unece: 'LTR', fractional: true },
    M: { code: 'M', label: 'Meter', short: 'm', unece: 'MTR', fractional: true },
    M2: { code: 'M2', label: 'Quadratmeter', short: 'm²', unece: 'MTK', fractional: true },
    STD: { code: 'STD', label: 'Stunde', short: 'Std', unece: 'HUR', fractional: true },
    TAG: { code: 'TAG', label: 'Tag', short: 'Tag', unece: 'DAY', fractional: true },
    PAU: { code: 'PAU', label: 'Pauschal', short: 'pausch.', unece: 'C62', fractional: false },
};
export const DEFAULT_UNIT = 'STK';
export function getUnit(code) {
    const unit = UNITS[code];
    if (!unit)
        throw new Error(`Unbekannte Mengeneinheit: ${code}`);
    return unit;
}
export function unitList() {
    return Object.values(UNITS);
}
//# sourceMappingURL=units.js.map